define('viewmodels/404',[], function () {
    var viewModel = {
        homeUrl: '#sections'
    };

    return viewModel;
});
